export const getCurrentDay = () => {
  return new Intl.DateTimeFormat("en-GB", { weekday: "long" })
    .format(new Date())
    .toLowerCase();
};
